export default __webpack_public_path__ + "static/media/L_LVT.b5d03c79.jpg";